export default __webpack_public_path__ + "static/media/0x255707b70bf90aa112006e1b07b9aea6de021424.f2cc60f9.webp";